import React, { useContext } from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import { EnvironmentContext } from 'view/shared/environment'
import { Organisation } from 'api'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { HomeTile } from './HomeTile'
import { UserSettings } from './userSettings/UserSettings'
import { openOrganisationsSelector } from 'selectors/selectionSelectors'
import { GlobalNavigationTab } from './GlobalNavigationTab'
import { initialSnapshotsLoadedSelector } from 'selectors/systemSelectors'
import { LoginBackground } from '../login/LoginBackground'
import { StatusPanel } from '../login/StatusPanel'
import { diagnosticsLogger } from 'logger/diagnosticsLogger'

interface GlobalNavigationProps {
  openOrganisations: Organisation[]
  initialSnapshotsLoaded: boolean
  children?: React.ReactNode
}

const GlobalCaption = 'Global'

const mapStateToProps = createStructuredSelector({
  openOrganisations: openOrganisationsSelector,
  initialSnapshotsLoaded: initialSnapshotsLoadedSelector
})

const mapDispatchToProps = {}

const GlobalNavigationWrapper = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

const GlobalNavigationHeader = styled.header`
  flex: 0 0 auto;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  background-color: ${constants.CORE_PRIMARY_6};
  position: relative;
  z-index: 2;
  padding: 0 0 0 10px;
  & > * {
    margin-right: 10px;
  }
`

const GlobalNavigationBar = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;
  height: 100%;
`

const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1 auto;
`

const GlobalNavigationComponent: React.FunctionComponent<GlobalNavigationProps> = props => {
  const environment = useContext(EnvironmentContext)

  const { openOrganisations, children, initialSnapshotsLoaded } = props

  if (!initialSnapshotsLoaded) {
    diagnosticsLogger.log('Initial snapshots not loaded. Rendering LoginBackground')
    return (
      <LoginBackground>
        <StatusPanel statuses={[]} />
      </LoginBackground>
    )
  }

  if (!environment.isAdmin) {
    return <>{children}</>
  }

  return (
    <GlobalNavigationWrapper>
      <GlobalNavigationHeader>
        <GlobalNavigationBar role="navigation">
          <HomeTile showLogo={false} />
          <GlobalNavigationTab organisationId={null} caption={GlobalCaption} />
          {openOrganisations.map(organisation => (
            <GlobalNavigationTab key={organisation.id} organisationId={organisation.id} caption={organisation.legalName} />
          ))}
        </GlobalNavigationBar>
        <ToolbarContainer />
        <UserSettings />
      </GlobalNavigationHeader>
      {children}
    </GlobalNavigationWrapper>
  )
}

export const GlobalNavigation = connect(mapStateToProps, mapDispatchToProps)(GlobalNavigationComponent)
